/**
 * Header tools.
 */
H_Tools.header = (() => {
    /**
     * Sets the stored height of the header to the specified value.
     *
     * @param {*} headerHeight A new height for the header
     */
    function setHeaderHeight(headerHeight) {
        // console.log(`Header height: ${headerHeight}`);
        document.documentElement.style.setProperty(
            '--header-height',
            `${headerHeight}px`
        );
        H_Tools.header.currentHeaderHeight = headerHeight;
    }

    // Return an object to expose inner functions
    return {
        currentHeaderHeight: 0,
        setHeaderHeight: setHeaderHeight,
    };
})();
